export const Theme = {
  darkBgColor: 'rgba(0,7,18,0.9)',
  darkBgColorSolid: 'rgba(0,7,18,1)',
  mediumBgColor: 'rgb(34,34,39)',
  otherGrey: 'rgb(51,51,58)',
  otherGrey2: 'rgb(72,72,80)',
  badgeBgColor: 'rgba(0,7,18,0.9)',
  badgeBorderColor: 'rgba(140,150,160,1)',
  lightBgColor: 'rgba(255,255,255,0.4)',
  textColor: 'rgba(255,255,255,0.8)',
  physicalColor: '#adcae6',
  magicColor: 'plum',
  evasionColor: 'rgb(133, 199, 133)',
  playerPartyColor: '#adcae6',
  enemyPartyColor: 'lightsalmon',
  meleeRangeColor: 'rgba(255,255,255,0.8)',
  rangedRangeColor: 'rgba(255,255,255,0.8)',
  healthRedColor: 'rgb(151,75,75)',

  paddingS: '4px',
  padding: '8px',
  paddingL: '16px',
  paddingXL: '24px',

  titleFont: 'New Rocker',
}
